export default {
  partnersList: []
}
